const { useState, useEffect, useRef, useMemo } = React;
// npx webpack //to compile js

const Dropdown = ({ label, name, options, selectedValues, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef();

  const handleCheckboxChange = (value) => {
    if (selectedValues.includes(value)) {
      onSelect(
        name,
        selectedValues.filter((v) => v !== value)
      );
    } else {
      onSelect(name, [...selectedValues, value]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };

    function handleClick(e) {
      if (wrapperRef && wrapperRef.current) {
        let ref = wrapperRef.current;
        if (!ref.contains(e.target)) {
          setIsOpen(false);
        }
      }
    }
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <div className="e-f-filters-inner">
      <button className="e-f-btn" onClick={(e) => toggleDropdown(e)}>
        <div className="e-f-filter-img-wrapper">
          <img
            className="e-f-active-img"
            src="/sites/default/files/redesign/filter-tick-svgrepo-com.svg"
            alt="filter active"
          />
          {selectedValues.length > 0 && <span className="e-f-filter-count">{selectedValues.length}</span>}
        </div>

        {label}
        <img
          className="e-f-btn-arrow-img"
          style={{ transform: isOpen ? "rotate(30deg)" : "none" }}
          src="/sites/default/files/redesign/filter-drop-icon.svg"
          alt="arrow"
        />
      </button>
      {isOpen && (
        <div ref={wrapperRef} className="e-f-dropdown">
          {options.map((option) => (
            <label
              style={{
                backgroundColor: selectedValues.includes(option.value) && "black",
              }}
              key={option.value}
              className="e-f-filter"
            >
              <span
                style={{
                  color: selectedValues.includes(option.value) ? "#fff" : "black",
                }}
                className="e-f-filter-title"
              >
                {option.label}
              </span>
              <input
                type="checkbox"
                id={`${name}-${option.value}`}
                checked={selectedValues.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
              />
              {selectedValues.includes(option.value) ? (
                <img
                  className="e-f-filter-active"
                  src="/sites/default/files/redesign/filter-active.svg"
                  alt="checkmark"
                />
              ) : null}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const translations = {
  en: {
    designCenters: {
      "dc-sofia": "Sofia",
      "dc-barcelona": "Barcelona",
      "dc-salzburg": "Salzburg",
      "dc-szczecinek": "Szczecinek",
      "dc-lampertswalde": "Lampertswalde",
      "dc-bucharest": "Bucharest",
      "dc-london": "London",
      "dc-instanbul": "Istanbul",
    },
    types: {
      presentation: "Presentation",
      workshop: "Workshop",
      collaboration: "Collaboration",
    },
  },
  bg: {
    designCenters: {
      "dc-sofia": "София",
      "dc-barcelona": "Барселона",
      "dc-salzburg": "Залцбург",
      "dc-szczecinek": "Щчечинек",
      "dc-lampertswalde": "Лампертсвалде",
      "dc-bucharest": "Букурещ",
      "dc-london": "Лондон",
      "dc-instanbul": "Истанбул",
    },
    types: {
      presentation: "Презентация",
      workshop: "Работилница",
      collaboration: "Сътрудничество",
    },
  },
  es: {
    designCenters: {
      "dc-sofia": "Sofía",
      "dc-barcelona": "Barcelona",
      "dc-salzburg": "Salzburgo",
      "dc-szczecinek": "Szczecinek",
      "dc-lampertswalde": "Lampertswalde",
      "dc-bucharest": "Bucarest",
      "dc-london": "Londres",
      "dc-instanbul": "Estambul",
    },
    types: {
      presentation: "Presentación",
      workshop: "Taller",
      collaboration: "Colaboración",
    },
  },
};

const designCenterValues = [
  "dc-sofia",
  "dc-barcelona",
  "dc-salzburg",
  "dc-szczecinek",
  "dc-lampertswalde",
  "dc-bucharest",
  "dc-london",
  "dc-instanbul",
];

const typeValues = ["presentation", "workshop", "collaboration"];

const getTranslation = (lang, category, key) => {
  return translations[lang]?.[category]?.[key] || translations["en"][category][key];
};

const EventItem = ({ item }) => {
  const [opacity, setOpacity] = useState(0);

  const handleImageLoad = () => {
    setOpacity(1);
  };

  useEffect(() => {
    setOpacity(0);
  }, [item]);

  return (
    <div className="e-f-event">
      <div className="e-f-event-left">
        <div className="e-f-event-line-top"></div>
        <div className="e-f-event-line-bottom"></div>
        <div className="e-f-event-left-inner">
          <div className="e-f-event-desc-wrapper">
            <h3 className="e-f-event-heading">{item.translations[0].title}</h3>
            <p className="e-f-event-desc-text">{item.translations[0].description}</p>
            <span className="e-f-event-time">{item.translations[0].date}</span>
            <span className="e-f-event-location">{item.translations[0].location}</span>
          </div>
        </div>
      </div>
      <div className="e-f-event-right">
        <img
          style={{ opacity: opacity }}
          className="e-f-event-img"
          src={item.translations[0].image}
          alt="Krono DC event image"
          loading="lazy"
          onLoad={handleImageLoad}
          key={item.translations[0].image}
        />
      </div>
    </div>
  );
};

const App = () => {
  const [filterValues, setFilterValues] = useState({
    designCenters: [],
    type: [],
  });
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const lang = window.location.pathname.split("/")[1];
  //const lang = "es";
  const host = window.location.origin;
  //const host = "https://krono-dc.dev.creatizmo.com";

  const handleSelect = (name, values) => {
    setFilterValues((prev) => ({ ...prev, [name]: values }));
  };

  const clearFilters = () => {
    setFilterValues({
      designCenters: [],
      type: [],
    });
  };

  const getEventsData = async (language) => {
    const response = await fetch(`${host}/api/events?language=${language}`);
    const data = await response.json();
    setEvents(data.events);
    setLoading(false);
  };

  useEffect(() => {
    if (lang) getEventsData(lang);
  }, []);

  const designCenterOptions = useMemo(() => {
    return designCenterValues.map((value) => ({
      label: getTranslation(lang, "designCenters", value),
      value: value,
    }));
  }, [lang, designCenterValues]);

  const typeOptions = useMemo(() => {
    return typeValues.map((value) => ({
      label: getTranslation(lang, "types", value),
      value: value,
    }));
  }, [lang, typeValues]);

  const filteredData = useMemo(() => {
    return events?.filter((item) => {
      const { designCenters, type } = filterValues;
      return (
        (!designCenters.length || designCenters.includes(item.designCenter)) &&
        (!type.length || type.includes(item.type))
      );
    });
  }, [events, filterValues.designCenters, filterValues.type]);

  return (
    <div className="container">
      {loading && (
        <div className="events-loader-wrapper">
          <span className="events-loader"></span>
        </div>
      )}
      <div className="e-f-filters-container">
        <Dropdown
          label={lang === "en" ? "Design center" : lang === "bg" ? "Дизайн център" : "Diseño centro"}
          name="designCenters"
          options={designCenterOptions}
          selectedValues={filterValues.designCenters}
          onSelect={handleSelect}
        />
        <Dropdown
          label={lang === "en" ? "Type" : lang === "bg" ? "Вид" : "Tipo"}
          name="type"
          options={typeOptions}
          selectedValues={filterValues.type}
          onSelect={handleSelect}
        />
        {(filterValues.designCenters.length > 0 || filterValues.type.length > 0) && (
          <button onClick={clearFilters} className="e-f-clear-btn">
            {lang === "en" ? "Clear" : lang === "bg" ? "Изчисти" : "Borrar"}
          </button>
        )}
      </div>

      {!filteredData?.length ? (
        <div className="e-f-no-events">
          <h3>{lang === "en" ? "No events." : lang === "bg" ? "Няма събития." : "No hay eventos."}</h3>
        </div>
      ) : (
        filteredData?.map((item) => {
          if (!item.translations[0]) return null;
          return <EventItem key={item.translations[0].image} item={item} />;
        })
      )}
    </div>
  );
};

ReactDOM.render(<App />, document.getElementById("custom-filter-events"));
